import React, { useState, useEffect } from 'react';	
import { useUser } from '../context/UserContext';
import SignUp from '../components/SignUp';
import SignOut from '../components/SignOut';
import { useNavigate } from "react-router-dom";

const SignUpPage = () => {
  const { user, isLoggedIn } = useUser();
const navigate = useNavigate();
  useEffect(() => {
    if (isLoggedIn){
    navigate("/");};
  }, [isLoggedIn]);
  return (
    <div>
      {isLoggedIn ? (
        <div>
          
        </div>
      ) : (
        <div>
          <SignUp />
        </div>
      )}
    </div>
  );
};
export default SignUpPage;

